import { reactive, readonly } from 'vue'

import { events$ } from '@/services'

import useBasket from '@/hooks/useBasket'
import useBackend from '@/hooks/useBackend'
import useDistribution from '@/hooks/useDistribution'
import useLogger from '@/hooks/useLogger'

import { EVENT_BASKET } from '@/config/events'
import config from '@/config'
import { ReactivityUtil } from '@/utils/Reactivity'
import { CHANNEL } from '@/config/constants'

const { hasImmigratedPerson } = useBasket()
const { setup, doGet } = useBackend()
const { getDistributionPartnerNumber } = useDistribution()
const { logInfo } = useLogger()

setup('/ovpv3/public', config.microserviceBaseUrl, {
  responseSuccess: response => {
    return response.data
  },
  responseError: error => {
    return Promise.reject(error)
  },
})

// Data
const incentive = reactive({})

events$.on(EVENT_BASKET.UPDATED, ({ basket, originalBasket }) => {
  if (!basket.basketId) return

  const needsUpdateOrInstall =
    (originalBasket === undefined && basket !== undefined) ||
    basket.language !== originalBasket.language ||
    basket.channel !== originalBasket.channel ||
    hasImmigratedPerson(basket) !== hasImmigratedPerson(originalBasket) ||
    getDistributionPartnerNumber(basket.distributionPartners) !==
      getDistributionPartnerNumber(originalBasket.distributionPartners)

  if (needsUpdateOrInstall) {
    install(basket)
  }
})

export default function useIncentive() {
  return {
    incentive: readonly(incentive),
    install,
  }
}

async function install(basket) {
  const { language, channel } = basket
  const distributionPartnerNumber = getDistributionPartnerNumber(basket.distributionPartners)
  const data = await fetchIncentive({
    language,
    channel: channel || CHANNEL.OVP,
    immigrant: hasImmigratedPerson(basket),
    distributionPartnerNumber,
  })

  return setIncentive(data)
}

function setIncentive(payload) {
  ReactivityUtil.reAssign(incentive, payload)
  logInfo(['%cINCENTIVE SET', 'color: green', incentive])
  return incentive
}

async function fetchIncentive(payload) {
  const response = await doGet('/incentives', payload)
  return response.data
}
